export function showCardVerification({ state, action }) {
  return {
    ...state,
    isSpinnerVisible: false,
    verifyPaymentAmount: action.amount,
    verifyPaymentBillingInfo: action.billingInfo,
    verifyPaymentBin: action.bin,
    verifyPaymentNonce: action.paymentMethodNonce,
  };
}

export function hideCardVerification({ state }) {
  return {
    ...state,
    verifyPaymentAmount: null,
    verifyPaymentBillingInfo: null,
    verifyPaymentBin: null,
    verifyPaymentNonce: null,
  };
}

export function finishVerificationRequest({ state }) {
  return { ...state, isSpinnerVisible: true };
}

export function finishVerificationSuccess({ state }) {
  return {
    ...state,
    isSpinnerVisible: false,
    verifyPaymentAmount: null,
    verifyPaymentBillingInfo: null,
    verifyPaymentBin: null,
    verifyPaymentNonce: null,
  };
}

export function finishVerificationError({ state }) {
  return {
    ...state,
    isSpinnerVisible: false,
    verifyPaymentAmount: null,
    verifyPaymentBillingInfo: null,
    verifyPaymentBin: null,
    verifyPaymentNonce: null,
  };
}
